import { BenefitDTOBenefitEnum, DocumentsDTO } from 'probonio-shared-ui/api';
import { BenefitNavigationExtensionInterface } from '../../../../extension/interface/benefit-navigation.extension.interface';
import { BenefitMenuItemInterface } from '../../nav/BenefitMenuItem';

export class ATLunchBenefitNavigationExtension extends BenefitNavigationExtensionInterface {
  getMenuItems({ documents }: { documents?: DocumentsDTO }): BenefitMenuItemInterface[] {
    const benefit = BenefitDTOBenefitEnum.AtLunch.toLowerCase();
    return [
      {
        title: 'subPage.employees',
        to: `/benefits/${benefit}`,
      },
      { title: `AT_LUNCH.receipts.title`, to: `/benefits/${benefit}/receipts` },
      { title: `AT_LUNCH.days.title`, to: `/benefits/${benefit}/days` },
      { title: `AT_LUNCH.settings.title`, to: `/benefits/${benefit}/settings` },
      { title: `subPage.payrollReport`, to: `/benefits/${benefit}/payrollReport` },
      ...(documents?.totalCount ? [{ title: 'subPage.documents', to: `/benefits/${benefit}/documents` }] : []),
    ];
  }
}
